import Reveal from "@/components/base/Reveal";
import { sobreStats } from "@/mocks/sobre";

export default function SobreStats() {
  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-2 gap-y-10 lg:grid-cols-4">
          {sobreStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 70}>
              <div className="lg:border-l lg:border-background-50/10 lg:pl-8">
                <p className="font-heading text-3xl font-bold text-background-50 md:text-4xl">
                  {stat.value}
                </p>
                <p className="mt-2 text-xs leading-snug text-background-300 md:text-sm">
                  {stat.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}